/* eslint-disable react/prop-types */
import React from "react";

import { sDown, sUp, mDown, mUp } from "./Media.module.scss";

export const SMediaDown = ({ children }) => <div className={sDown}>{children}</div>;
export const SMediaUp = ({ children }) => <div className={sUp}>{children}</div>;
export const MMediaDown = ({ children }) => <div className={mDown}>{children}</div>;
export const MMediaUp = ({ children }) => <div className={mUp}>{children}</div>;
